import React, { useEffect, useMemo } from 'react';

import { useApplicationState, useCasinoNewState, useCategoryGamesState } from '@atlas/core';
import { Loader } from '@atlas/ui';

import { CasinoCategory } from 'components/Pages/Casino/CasinoCategory';
import GameList from 'components/Pages/Casino/GameList/GameList';

const SEARCH_CATEGORIES_COUNT = 2;

const SearchCategoryGamesList = ({ showCategoryHandler, sliderSettings }) => {
  const { categoryGames, loading } = useCategoryGamesState();
  const { authenticated } = useApplicationState();
  const { identifyFavoriteGames } = useCasinoNewState();

  const searchCategoryGames = useMemo(() => {
    return [...categoryGames]
      .sort((a, b) => a.position - b.position)
      .slice(0, SEARCH_CATEGORIES_COUNT);
  }, [categoryGames]);

  useEffect(() => {
    if (!authenticated) return;

    let gameIds = [];

    searchCategoryGames.forEach(({ games }) => {
      gameIds = gameIds.concat(games.map(({ id }) => id));
    });

    if (gameIds.length) {
      identifyFavoriteGames(gameIds);
    }
  }, [searchCategoryGames, authenticated]);

  if (!searchCategoryGames.length && loading) return <Loader />;

  return (
    <>
      {searchCategoryGames.map(({ games, iconUrl, id, name }) => (
        <CasinoCategory
          InfoGamesList={GameList}
          games={games}
          iconUrl={iconUrl}
          id={id}
          key={id}
          name={name}
          showCategoryHandler={showCategoryHandler}
          sliderSettings={sliderSettings}
        />
      ))}
    </>
  );
};

export default SearchCategoryGamesList;
